import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const WarningMessage = () => {
  const [visible, setVisible] = useState(true);
  const [counter, setCounter] = useState(10);
  const [fadeOut, setFadeOut] = useState(false);
  const {t} = useTranslation()

  useEffect(() => {
    if (!visible) return;

    const timer = setInterval(() => {
      setCounter((prev) => {
        if (prev === 1) {
          setFadeOut(true); // bosqichma-bosqich yo'qoladi
          setTimeout(() => setVisible(false), 1000); // 1s fade-out animatsiya uchun
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="warningText"
    >
      <span className="block font-medium">
       {t("warningMessage")}
      </span>
      <div className="timeWarning"> {counter} s</div>
    </div>
  );
};

export default WarningMessage;
